module.exports = __webpack_public_path__ + "img/h1.cd207dc9.png";